import {StringConstant} from "../StringConstant";
import {StoreKeys} from "../StoreKeys";

export function getNodeInductServiceBaseURL() {
    switch(getStage()) {
        case 'beta':
            switch(getRegion()) {
                case StringConstant.REGION_NA: return "https://dolphin-preprod.amazon.com";
                case StringConstant.REGION_EU: return "https://dolphin-preprod.amazon.eu";
                case StringConstant.REGION_IN: return "https://dolphin-preprod.amazon.eu/in";
                // no default
            }
            /* istanbul ignore next */
            break;
        case 'gamma':
            switch(getRegion()) {
                case StringConstant.REGION_NA: return "https://dolphin-preprod.amazon.com";
                case StringConstant.REGION_EU: return "https://dolphin-preprod.amazon.eu";
                case StringConstant.REGION_FE: return "https://dolphin-fe-preprod.amazon.com";
                case StringConstant.REGION_IN: return "https://dolphin-preprod.amazon.eu/in";
                // no default
            }
            /* istanbul ignore next */
            break;
        case 'prod':
            switch(getRegion()) {
                case StringConstant.REGION_NA: return "https://dolphin.amazon.com";
                case StringConstant.REGION_EU: return "https://dolphin.amazon.eu";
                case StringConstant.REGION_FE: return "https://dolphin-fe.amazon.com";
                case StringConstant.REGION_IN: return "https://dolphin.amazon.eu/in";
                // no default
            }
            /* istanbul ignore next */
            break;
        // no default
    }
}

export function getPandaTokenExchangeURL() {
    switch(getRegion()) {
        case StringConstant.REGION_NA: return "https://api.amazon.com/auth/token";
        case StringConstant.REGION_IN:
        case StringConstant.REGION_EU: return "https://api.amazon.co.uk/auth/token";
        case StringConstant.REGION_FE: return "https://api.amazon.co.jp/auth/token";
        // no default
    }
    /* istanbul ignore next */
}

export function getRegion() {
    const hostname = window.location.hostname;
    if (hostname.startsWith('na')) return StringConstant.REGION_NA;
    else if (hostname.startsWith('eu')) return StringConstant.REGION_EU;
    else if (hostname.startsWith('fe')) return StringConstant.REGION_FE;
    else if (hostname.startsWith('in')) return StringConstant.REGION_IN;
    return StringConstant.REGION_NA;
}

function getStage() {
    const hostname = window.location.hostname.split('.');
    if (hostname[1] != null) {
        const stage = hostname[1];
        if (stage.endsWith('integ')) return 'beta';
        else if (stage.endsWith('master')) return 'gamma';
        else if (stage.endsWith('prod')) return 'prod';
        return 'gamma';
    }
    return 'gamma';
}

export function getPUMARegion() {
    const hostname = window.location.hostname;
    if (hostname.startsWith('na')) return 'na';
    else if (hostname.startsWith('eu')) return 'eu';
    else if (hostname.startsWith('fe')) return 'jp';
    else if (hostname.startsWith('in')) return 'eu';
    return 'jp';
}

export function getPUMACountry() {
    const hostname = window.location.hostname;
    if (hostname.startsWith('na')) return 'US';
    else if (hostname.startsWith('eu')) return 'UK';
    else if (hostname.startsWith('fe')) return 'JP';
    else if (hostname.startsWith('in')) return 'IN';
    return 'JP';
}

export function getPUMAStage() {
    const hostname = window.location.hostname.split('.');
    if (hostname[1] != null) {
        const stage = hostname[1];
        if (stage.endsWith('integ')) return 'test';
        else if (stage.endsWith('master')) return 'test';
        else if (stage.endsWith('prod')) return 'prod';
        return 'test';
    }
    return 'test';
}

export function getStationCode() {
    const baseInitializationParams = JSON.parse(localStorage.getItem(StoreKeys.BASE_INITIALIZATION_PARAMS));
    if (baseInitializationParams && baseInitializationParams.userPreferences &&
        baseInitializationParams.userPreferences.userProfile) {
        return baseInitializationParams.userPreferences.userProfile.stationCode;
    }
    else {
        console.log("Station Code Not Found");
        return "";
    }
}

export function getLoggerUrl() {
    switch(getStage()) {
        case 'beta':
            return "https://3rgkbcnf02.execute-api.us-west-2.amazonaws.com/prod/v1/log";
        case 'gamma':
            switch(getRegion()) {
                case StringConstant.REGION_NA: return "https://x1mqmcrgp4.execute-api.us-east-1.amazonaws.com/prod/v1/log";
                case StringConstant.REGION_EU: return "https://apjc9dw0wd.execute-api.eu-west-1.amazonaws.com/prod/v1/log";
                case StringConstant.REGION_FE: return "https://n8vnwa8bqi.execute-api.us-west-2.amazonaws.com/prod/v1/log";
                //TODO: Stage missing. Link to be added post stage creation
                case StringConstant.REGION_IN: return null;
                default:
                    return "https://x1mqmcrgp4.execute-api.us-east-1.amazonaws.com/prod/v1/log";
            }
        case 'prod':
            switch(getRegion()) {
                case StringConstant.REGION_NA: return "https://qovu9dbtkj.execute-api.us-east-1.amazonaws.com/prod/v1/log";
                case StringConstant.REGION_EU: return "https://b9ue0iocag.execute-api.eu-west-1.amazonaws.com/prod/v1/log";
                case StringConstant.REGION_FE: return "https://whxu9wlk8l.execute-api.us-west-2.amazonaws.com/prod/v1/log";
                //TODO: Stage missing. Link to be added post stage creation
                case StringConstant.REGION_IN: return null;
                default:
                    return "https://qovu9dbtkj.execute-api.us-east-1.amazonaws.com/prod/v1/log";
            }
        default:
            return "https://3rgkbcnf02.execute-api.us-west-2.amazonaws.com/prod/v1/log";
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/network/BaseURLUtils.js